import {
  TweenMax,
  TimelineLite
} from 'gsap'

export default {
  name: 'about',
  data: function () {
    return {
      about: true,
      design: false,
      dev: false,
      pwa: false
    }
  },
  computed: {
    english: function () {
      return this.$store.getters.english
    }
  },
  mounted: function () {
    if (window.innerWidth > 900) {
      TweenMax.to([this.$refs.design, this.$refs.dev, this.$refs.pwa], 0, {
        opacity: 0,
        transform: 'translateX(20px)',
        display: 'none'
      })
    }
  },
  methods: {
    designClicked() {
      var tl = new TimelineLite({
        paused: true
      })
      tl.to([this.$refs.dev, this.$refs.pwa, this.$refs.about], 0.4, {
          opacity: 0,
          transform: 'translateX(-20px)',
          display: 'none'
        })
        .to(this.$refs.design, 0.4, {
          opacity: 1,
          transform: 'translateX(0)',
          display: 'block'
        })
        .to([this.$refs.dev, this.$refs.pwa, this.$refs.about], 0.4, {
          transform: 'translateX(20px)'
        })
      tl.play()
      this.about = false
      this.design = true
      this.dev = false
      this.pwa = false
    },
    devClicked() {
      var tl = new TimelineLite({
        paused: true
      })
      tl.to([this.$refs.design, this.$refs.pwa, this.$refs.about], 0.4, {
          opacity: 0,
          transform: 'translateX(-20px)',
          display: 'none'
        })
        .to(this.$refs.dev, 0.4, {
          opacity: 1,
          transform: 'translateX(0)',
          display: 'block'
        })
        .to([this.$refs.design, this.$refs.pwa, this.$refs.about], 0.4, {
          transform: 'translateX(20px)'
        })
      tl.play()
      this.about = false
      this.design = false
      this.dev = true
      this.pwa = false
    },
    pwaClicked() {
      var tl = new TimelineLite({
        paused: true
      })
      tl.to([this.$refs.design, this.$refs.dev, this.$refs.about], 0.4, {
          opacity: 0,
          transform: 'translateX(-20px)',
          display: 'none'
        })
        .to(this.$refs.pwa, 0.4, {
          opacity: 1,
          transform: 'translateX(0)',
          display: 'block'
        })
        .to([this.$refs.design, this.$refs.dev, this.$refs.about], 0.4, {
          transform: 'translateX(20px)'
        })
      tl.play()
      this.about = false
      this.design = false
      this.dev = false
      this.pwa = true
    },
    aboutClicked() {
      var tl = new TimelineLite({
        paused: true
      })
      tl.to([this.$refs.design, this.$refs.dev, this.$refs.pwa], 0.4, {
          opacity: 0,
          transform: 'translateX(-20px)',
          display: 'none'
        })
        .to(this.$refs.about, 0.4, {
          opacity: 1,
          transform: 'translateX(0)',
          display: 'block'
        })
        .to([this.$refs.design, this.$refs.dev, this.$refs.pwa], 0.4, {
          transform: 'translateX(20px)'
        })
      tl.play()
      this.about = true
      this.design = false
      this.dev = false
      this.pwa = false
    },

  }
}


// WEBPACK FOOTER //
// ./src/components/about/about.js